module.exports = __webpack_public_path__ + "static/media/jack.6a8662f6.svg";